import { StateType } from '@central-products/interface-session-service';
import { subscribe, unsubscribe, publish, publishSticky } from '@wh/message-bus';

export const MY_ACCOUNT_VIEW_QUERY_PARAM = 'myAccountView';

export const waitForSession = () => {
  return new Promise((resolve) => {
    const sessionGetSubscription = subscribe({
      topic: 'wh.common.event.session.state.get',
      callback: ({ data }) => {
        if (data.state === 'NOT_LOGGED_IN') {
          publish('wh.common.event.ui.header.login.requested');
        }
        unsubscribe(sessionGetSubscription);
      },
    });

    const stateChangedSubscribeId = subscribe({
      topic: 'wh.common.event.sessionService.state.changed',
      callback: async ({ data }) => {
        if (data.state !== StateType.SESSION_EXISTS) {
          return;
        }
        unsubscribe(stateChangedSubscribeId);
        resolve();
      },
    });
  });
};

export const getMyAccountViewParam = (search) => {
  const urlparams = new URLSearchParams(search);
  return urlparams.get(MY_ACCOUNT_VIEW_QUERY_PARAM);
};

export const openMyAccountPage = (viewUrlParam, params) => {
  if (params.legacyMarketingConsentDeepLinkBehavior && viewUrlParam === 'personalDetailsMarketing') {
    publishSticky('wh.myAccount.command.dropdown.open', { path: '/PersonalDetails/Marketing' });
    return;
  }
  publishSticky('wh.myAccount.command.dropdown.open', {
    path: viewUrlParam,
  });
};

export const removeMyAccountViewParam = (search, fullUrl) => {
  const urlparams = new URLSearchParams(search);
  urlparams.delete(MY_ACCOUNT_VIEW_QUERY_PARAM);
  const queryStr = urlparams.toString();
  const rawUrl = fullUrl.split('?')[0];
  return `${rawUrl}${queryStr ? '?' + queryStr : ''}`;
};
